<template>
  <v-chip
    :x-small="xsmall"
    :small="small"
    outlined
    :color="prioridade.cor"
    class="font-weight-bold caption ml-2"
    >{{ prioridade.descricao }}
    <v-icon x-small right>{{ prioridade.icone }}</v-icon>
  </v-chip>
</template>

<script>
export default {
  props: {
    prioridade: { type: Object },
    xsmall: { type: Boolean,},
    small: { type: Boolean },
  },
};
</script>

<style>
</style>